import lib from '@/library'
// import Vue from 'vue'

const state = {
  tnc: {
    global: {},
    forSB: {
      checked: false,
      shouldReconfirm: false
    }
  }
}

const getters = {
  getSBtnc (state) {
    return state.tnc.forSB
  }
}

const actions = {
  is2ReconfirmTsAndCs4Area (context, force) {
    // console.log('is2ReconfirmTsAndCs4Area')
    if (!context.state.tnc.forSB.checked || force) {
      return lib.rpcService.callBroker('UserService', 'Is2ReconfirmTsAndCs4Area', {'IDMMCTArea': 'SPORTSBOOK'}).then(
        function (r) {
          if (!r.exceptionType) {
            context.state.tnc.forSB.checked = true
            context.state.tnc.forSB.shouldReconfirm = r.result
            // Auto confirm TnC
            if (r.result && context.rootGetters['sbBetslipState/autoAcceptSbTnC']) {
              context.dispatch('confirmTsAndCs4Area', true)
            }
          }
        }
      ).catch(
        function () {
          context.state.tnc.forSB.checked = false
        }
      )
    }
  },

  confirmTsAndCs4Area (context, auto) {
    return new Promise((resolve, reject) => {
      var r = auto || confirm('Click OK to confirmTsAndCs4Area')
      if (r) {
        return lib.rpcService.callBroker('UserService', 'ConfirmTsAndCs4Area', {'IDMMCTArea': 'SPORTSBOOK'}).then(
          function (result) {
            // console.log('ConfirmTsAndCs4Area:')
            // console.log(result)
            if (!result.exceptionType) {
              context.state.tnc.forSB.shouldReconfirm = false
              context.dispatch('is2ReconfirmTsAndCs4Area', true)
            }
            resolve(result)
          }
        ).catch(
          function () {
            // console.log('ConfirmTsAndCs4Area Error')
            reject(new Error('error'))
          }
        )
      } else {
        reject(new Error('canceled'))
      }
    })
  },

  onLogout (context) {
    context.state.tnc.forSB.checked = false
    context.state.tnc.forSB.shouldReconfirm = false
    // Vue.set(context.state.tnc.forSB, 'checked', false)
    // Vue.set(context.state.tnc.forSB, 'shouldReconfirm', false)
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/tnc.js